import { useTranslation } from 'react-i18next'
import { useExportGHGEmissionsReport } from '../../hooks/useExportGHGEmissionsReport'
import { MenuItem } from '@/components/common/MenuItem/MenuItem'
import useToastStore from '@/stores/useToastStore/useToastStore'

export type ExportGHGEmissionsReportProps = {
    reportId: string
    onClick?: () => void
}

export const ExportGHGEmissionsReport: React.FC<
    ExportGHGEmissionsReportProps
> = ({ reportId, onClick }) => {
    const { t } = useTranslation('translations')
    const addAlert = useToastStore((state) => state.addAlert)

    const { exportGHGEmissionsReport } = useExportGHGEmissionsReport(reportId)

    return (
        <MenuItem
            path="/"
            variant="ghost"
            label={t('common.export_report_dropdown.options.xls')}
            render={({ renderContents }) => (
                <button
                    className="group w-full outline-none"
                    onClick={() => {
                        addAlert({
                            variant: 'success',
                            title: t(
                                'reporting.export_report.success_toast.title'
                            ),
                            description: t(
                                'reporting.export_report.success_toast.description'
                            ),
                        })
                        onClick?.()
                        exportGHGEmissionsReport()
                    }}
                    data-testid="export-ghg-emissions-excel-button"
                >
                    {renderContents()}
                </button>
            )}
        />
    )
}
